export const categories = [
  { slug: 'dongzuo', name: '动作片', icon: 'ri-sword-line', count: 1280 },
  { slug: 'xiju', name: '喜剧片', icon: 'ri-emotion-happy-line', count: 960 },
  { slug: 'aiqing', name: '爱情片', icon: 'ri-heart-line', count: 850 },
  { slug: 'kehuan', name: '科幻片', icon: 'ri-rocket-line', count: 720 },
  { slug: 'kongbu', name: '恐怖片', icon: 'ri-ghost-line', count: 540 },
  { slug: 'jilu', name: '纪录片', icon: 'ri-film-line', count: 680 },
  { slug: 'donghua', name: '动画片', icon: 'ri-emotion-laugh-line', count: 920 },
  { slug: 'zhanzheng', name: '战争片', icon: 'ri-shield-line', count: 380 },
  { slug: 'xuanyi', name: '悬疑片', icon: 'ri-search-eye-line', count: 650 },
  { slug: 'jingsong', name: '惊悚片', icon: 'ri-alert-line', count: 470 },
];

export const featuredMovies = [
  {
    id: 1,
    title: '星际穿越',
    titleEn: 'Interstellar',
    category: '科幻片',
    rating: 9.4,
    year: 2014,
    quality: '蓝光',
    description: '一组探险者穿越虫洞，为人类寻找新家园的壮丽旅程。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20space%20exploration%20movie%20poster%20style%20with%20wormhole%20and%20astronaut%20silhouette%2C%20dark%20cosmic%20background%20with%20warm%20golden%20light%20accents%2C%20dramatic%20composition%2C%20film%20grain%20texture%2C%20minimalist%20poster%20design%2C%20professional%20movie%20artwork&width=600&height=900&seq=movie-1&orientation=portrait',
  },
  {
    id: 2,
    title: '肖申克的救赎',
    titleEn: 'The Shawshank Redemption',
    category: '剧情片',
    rating: 9.7,
    year: 1994,
    quality: '超清',
    description: '一个银行家被冤枉入狱，用二十年时间完成了一场惊天越狱。',
    image: 'https://readdy.ai/api/search-image?query=Hope%20and%20freedom%20themed%20movie%20poster%20with%20man%20standing%20in%20rain%20arms%20outstretched%2C%20dramatic%20lighting%20from%20above%2C%20dark%20moody%20background%20with%20warm%20highlights%2C%20cinematic%20film%20poster%20style%2C%20emotional%20and%20powerful%20composition&width=600&height=900&seq=movie-2&orientation=portrait',
  },
  {
    id: 3,
    title: '盗梦空间',
    titleEn: 'Inception',
    category: '科幻片',
    rating: 9.3,
    year: 2010,
    quality: '蓝光',
    description: '潜入梦境深处，在层层嵌套的梦境中完成不可能的任务。',
    image: 'https://readdy.ai/api/search-image?query=Dream%20within%20dream%20concept%20movie%20poster%20with%20surreal%20cityscape%20folding%20upward%2C%20dark%20blue%20and%20gold%20color%20scheme%2C%20mind%20bending%20visual%20composition%2C%20cinematic%20film%20poster%20design%2C%20mysterious%20atmosphere&width=600&height=900&seq=movie-3&orientation=portrait',
  },
  {
    id: 4,
    title: '泰坦尼克号',
    titleEn: 'Titanic',
    category: '爱情片',
    rating: 9.4,
    year: 1997,
    quality: '超清',
    description: '一段跨越阶层的爱情，在巨轮沉没的背景下绽放出永恒的光芒。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20epic%20movie%20poster%20with%20couple%20on%20ship%20bow%20at%20sunset%2C%20warm%20golden%20orange%20sky%2C%20ocean%20background%2C%20classic%20cinematic%20film%20poster%20style%2C%20nostalgic%20and%20dreamy%20atmosphere&width=600&height=900&seq=movie-4&orientation=portrait',
  },
  {
    id: 5,
    title: '阿甘正传',
    titleEn: 'Forrest Gump',
    category: '剧情片',
    rating: 9.5,
    year: 1994,
    quality: '蓝光',
    description: '一个简单的人，用他的纯真和坚持，跑出了不平凡的一生。',
    image: 'https://readdy.ai/api/search-image?query=Man%20sitting%20on%20bench%20with%20box%20of%20chocolates%20movie%20poster%20style%2C%20soft%20warm%20natural%20light%2C%20green%20park%20background%2C%20nostalgic%20cinematic%20film%20poster%20design%2C%20simple%20and%20heartwarming%20composition&width=600&height=900&seq=movie-5&orientation=portrait',
  },
  {
    id: 6,
    title: '霸王别姬',
    titleEn: 'Farewell My Concubine',
    category: '剧情片',
    rating: 9.6,
    year: 1993,
    quality: '超清',
    description: '两个京剧伶人半个世纪的悲欢离合，折射出大时代的变迁。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20Peking%20opera%20themed%20movie%20poster%20with%20elaborate%20traditional%20costume%20and%20makeup%2C%20dramatic%20stage%20lighting%2C%20rich%20red%20and%20gold%20color%20palette%2C%20cinematic%20art%20film%20poster%20style%2C%20emotional%20and%20tragic%20atmosphere&width=600&height=900&seq=movie-6&orientation=portrait',
  },
  {
    id: 7,
    title: '千与千寻',
    titleEn: 'Spirited Away',
    category: '动画片',
    rating: 9.4,
    year: 2001,
    quality: '蓝光',
    description: '小女孩千寻误入神灵世界，用勇气和善良找回了自己的名字。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20movie%20poster%20with%20young%20girl%20in%20magical%20spirit%20bathhouse%2C%20vibrant%20warm%20colors%2C%20fantasy%20elements%2C%20whimsical%20and%20dreamy%20atmosphere%2C%20Studio%20Ghibli%20inspired%20art%20style&width=600&height=900&seq=movie-7&orientation=portrait',
  },
  {
    id: 8,
    title: '蝙蝠侠：黑暗骑士',
    titleEn: 'The Dark Knight',
    category: '动作片',
    rating: 9.2,
    year: 2008,
    quality: '蓝光',
    description: '蝙蝠侠与小丑的终极对决，正义与混乱的永恒较量。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20knight%20silhouette%20against%20burning%20city%20skyline%20movie%20poster%20style%2C%20dramatic%20orange%20and%20black%20contrast%2C%20heroic%20yet%20dark%20atmosphere%2C%20cinematic%20film%20poster%20design%2C%20intense%20and%20powerful%20composition&width=600&height=900&seq=movie-8&orientation=portrait',
  },
];

export const popularTVShows = [
  {
    id: 101,
    title: '权力的游戏',
    titleEn: 'Game of Thrones',
    category: '奇幻剧',
    rating: 9.4,
    episodes: 73,
    quality: '蓝光',
    description: '维斯特洛大陆上，各大家族为争夺铁王座展开的权力博弈。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20TV%20series%20poster%20with%20iron%20throne%20silhouette%20and%20dragon%20shadow%2C%20dark%20medieval%20atmosphere%2C%20dramatic%20lighting%2C%20cinematic%20television%20poster%20design%2C%20grand%20and%20majestic%20composition&width=600&height=900&seq=tv-1&orientation=portrait',
  },
  {
    id: 102,
    title: '绝命毒师',
    titleEn: 'Breaking Bad',
    category: '犯罪剧',
    rating: 9.5,
    episodes: 62,
    quality: '超清',
    description: '一位化学老师变身制毒大师的传奇故事，人性的黑暗与挣扎。',
    image: 'https://readdy.ai/api/search-image?query=Desert%20landscape%20with%20RV%20vehicle%20and%20chemical%20elements%20TV%20series%20poster%20style%2C%20warm%20amber%20and%20teal%20color%20palette%2C%20gritty%20cinematic%20look%2C%20intense%20and%20suspenseful%20atmosphere&width=600&height=900&seq=tv-2&orientation=portrait',
  },
  {
    id: 103,
    title: '琅琊榜',
    titleEn: 'Nirvana in Fire',
    category: '古装剧',
    rating: 9.4,
    episodes: 54,
    quality: '超清',
    description: '天下第一大帮江左盟宗主梅长苏化名苏哲，重返帝都金陵复仇雪冤。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20scholar%20in%20traditional%20white%20robe%20in%20ancient%20Chinese%20setting%2C%20ink%20wash%20painting%20style%2C%20elegant%20and%20refined%20atmosphere%2C%20misty%20mountain%20background%2C%20classical%20Chinese%20aesthetic&width=600&height=900&seq=tv-3&orientation=portrait',
  },
  {
    id: 104,
    title: '切尔诺贝利',
    titleEn: 'Chernobyl',
    category: '历史剧',
    rating: 9.6,
    episodes: 5,
    quality: '蓝光',
    description: '1986年切尔诺贝利核灾难的真相，以及那些勇敢面对的人们。',
    image: 'https://readdy.ai/api/search-image?query=Soviet%20era%20industrial%20disaster%20TV%20miniseries%20poster%20with%20nuclear%20plant%20silhouette%20and%20radiation%20symbol%2C%20cold%20gray%20and%20ominous%20yellow%20color%20scheme%2C%20dark%20and%20haunting%20atmosphere&width=600&height=900&seq=tv-4&orientation=portrait',
  },
  {
    id: 105,
    title: '甄嬛传',
    titleEn: 'Empresses in the Palace',
    category: '古装剧',
    rating: 9.3,
    episodes: 76,
    quality: '超清',
    description: '少女甄嬛从一个不谙世事的闺阁少女成长为善于权谋的皇太后。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20palace%20drama%20poster%20with%20noble%20woman%20in%20elaborate%20traditional%20imperial%20costume%2C%20rich%20red%20and%20gold%20palace%20interior%2C%20opulent%20classical%20Chinese%20aesthetic%2C%20dramatic%20and%20elegant%20composition&width=600&height=900&seq=tv-5&orientation=portrait',
  },
  {
    id: 106,
    title: '黑镜',
    titleEn: 'Black Mirror',
    category: '科幻剧',
    rating: 9.2,
    episodes: 27,
    quality: '蓝光',
    description: '每一集都是一个独立的故事，探讨科技对人类社会的深刻影响。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20reflective%20screen%20with%20cracked%20glass%20effect%20TV%20series%20poster%20style%2C%20dystopian%20technology%20theme%2C%20black%20and%20neon%20color%20scheme%2C%20ominous%20and%20thought%20provoking%20atmosphere&width=600&height=900&seq=tv-6&orientation=portrait',
  },
];

export const faqData = [
  {
    q: '91免费在线视频真的完全免费吗？',
    a: '是的，91免费在线视频平台所有内容均免费提供。我们致力于让每一位用户都能享受高品质的观影体验，无需支付任何费用。只需打开网站即可畅享海量高清电影和电视剧。',
  },
  {
    q: '观看需要注册账号吗？',
    a: '不需要！91免费在线视频无需注册即可观看所有内容。我们相信观影应该简单直接，点击播放按钮就能立即开始享受蓝光画质的精彩内容。',
  },
  {
    q: '为什么视频播放不会卡顿？',
    a: '我们采用了先进的CDN加速技术和智能缓冲算法，在全球部署了多个加速节点。同时，我们的视频经过了高效的压缩编码，在保证画质的前提下最大化降低带宽需求，确保播放流畅不卡顿。',
  },
  {
    q: '支持哪些设备观看？',
    a: '91免费在线视频支持所有主流设备，包括电脑（Windows/Mac）、平板（iPad/Android）、手机（iOS/Android）等。只需使用浏览器访问即可，无需下载任何APP。',
  },
  {
    q: '视频画质有哪些选择？',
    a: '我们提供超清、蓝光等多种画质选择。大部分影片都支持蓝光画质（1080P），部分热门影片更支持4K超高清。系统会根据您的网络状况自动推荐最佳画质，您也可以手动切换。',
  },
  {
    q: '内容多久更新一次？',
    a: '我们的内容团队每日更新，确保最新热门电影和电视剧第一时间上线。同时，经典影片库也在持续扩充中，让您总有新鲜内容可看。',
  },
];

export const statsData = [
  { label: '高清影片', value: '50,000+' },
  { label: '每日更新', value: '200+' },
  { label: '活跃用户', value: '800万+' },
  { label: '播放时长', value: '10亿+小时' },
];